<template>
    <div :key="text">
        <!-- {{ text }} -->
        <div class="asd" ref="asd" :style="{'font-size': fontSize + 'px', color, }"></div> 
    </div>
</template>

<script>
    /* eslint-disable */
    export default {
        data() {
            return {
            }
        },
        props: {
            text: {
                type: String,
                default: ''
            },
            color: {
                type: String,
                default: '#000'
            },
            fontSize: {
                type: Number,
                default: 32
            },
        },
        mounted() {
            katex.render(this.text, this.$refs.asd, {
                throwOnError: true
            })
        },
        destroyed() {
            // this.clipboard.destroy()
        },
        methods: {
        },
        watch: {
            text() {
                console.log('change')
                // katex.render(this.text, this.$refs.asd, {
                //     throwOnError: false
                // })
            }
        }
    }
</script>

<style lang="scss" scoped>
.asd {
    font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/latex/page.vue